import { CombinedGraphQLErrors } from '@apollo/client/errors';

export function extractErrorCode(error: unknown): string {
    if (CombinedGraphQLErrors.is(error)) {
        const code = error.errors[0]?.extensions?.code;
        if (typeof code === 'string') return code;
    }
    return 'UNKNOWN';
}
